const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrantMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M227.1,0h-59c-16,0-28.9,13.1-28.9,29.1v59.5c0,16,12.9,29,28.9,29.1h59c16,0,28.9-13.1,28.9-29.1V29.2C255.9,13.1,243,0,227.1,0ZM233.4,86.7c0,5.5-4.4,10-9.9,10h-52.3c-5.4,0-9.9-4.5-9.9-10v-54.4c0-5.5,4.4-10,9.9-10h52.3c5.5,0,9.9,4.5,9.9,10v54.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,137.9H29.5c-16,0-28.9,13.1-28.9,29.1v59.5c0,16,12.9,29,28.9,29.1h59c16-.1,28.9-13.1,28.9-29.1v-59.5c0-16.1-13-29.1-28.9-29.1ZM94.8,224.6c0,5.5-4.4,9.9-9.9,10h-52.3c-5.5,0-9.9-4.5-9.9-10v-54.4c0-5.5,4.4-10,9.9-10h52.3c5.5,0,9.9,4.5,9.9,10v54.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,0H28.9C12.9.2,0,13.2,0,29.2v59.5c0,16,12.9,29,28.9,29.1h59c16,0,28.9-13.1,28.9-29.1V29.2c0-16.1-13-29.1-28.9-29.1ZM94.2,86.7c0,5.5-4.4,10-9.9,10h-52.2c-5.5,0-9.9-4.5-9.9-10v-54.4c0-5.5,4.4-10,9.9-10h52.3c5.5,0,9.9,4.5,9.9,10v54.4Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,149.6l16.9-12.1,22.2,35.6c2.1,3.4,2.3,7.6.5,11.2-1.7,3.5-5.2,5.7-9,5.8h-84.6v-21.8h65.5l-11.7-18.6h0Z",
    style: {
      fill: "red",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.3,203.1h84.6v21.8h-65.5l11.6,18.6-16.9,12.1-22.3-35.6c-2.1-3.4-2.3-7.6-.5-11.2,1.7-3.5,5.2-5.7,9-5.8Z",
    style: {
      fill: "red",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197 243.6 197 243.6 197 243.5 197 243.6",
    style: {
      fill: "red",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantMenu);
export default __webpack_public_path__ + "static/media/grant-menu.fabf4162000de8a142711361362cf88d.svg";
export { ForwardRef as ReactComponent };